// Generated by `bazel run i18n`. Do not edit by hand.
import en from "./en/backend-common.json";

export default en;
